// extracted by mini-css-extract-plugin
module.exports = {"pokemon":"Pokemon_pokemon__315AK","pokemon_img":"Pokemon_pokemon_img__2yiqB","pokemon_details":"Pokemon_pokemon_details__1FD8k","link":"Pokemon_link__21DiM"};